import React from 'react'
import { Box, Divider, Typography, Tooltip } from '@material-ui/core'
import InfoIcon from '@material-ui/icons/Info'
import currency from 'currency.js'

const PriceRow = ({
  label,
  value,
  primary = false,
  negativeValue = false,
  hide = false,
  showToolTip = false,
  toolTipLabel = null,
}) => (
  <Box display={hide ? 'none' : 'flex'} justifyContent="space-between">
    <Box display={hide ? 'none' : 'flex'} justifyContent="start">
      <Typography variant={primary ? 'h5' : 'body1'} style={{ marginRight: '5px' }}>
        {label}
      </Typography>
      {showToolTip ? (
        <Tooltip disableFocusListener disableTouchListener title={toolTipLabel}>
          <InfoIcon fontSize="small" style={{ color: 'ABADB2', lineHeight: '14px' }} />
        </Tooltip>
      ) : (
        <></>
      )}
    </Box>
    <Typography variant={primary ? 'h5' : 'body1'}>
      {negativeValue && '- '}
      {typeof value === 'number' ? currency(value, { formatWithSymbol: true }).format() : value}
    </Typography>
  </Box>
)

const SubtotalPreTax = ({
  couponAmount,
  couponApplied,
  couponCode,
  creditsApplied,
  creditsUsed,
  orderFee,
  subtotal,
}) => {
  const isFreeDelivery = orderFee === 0
  return (
    <>
      <PriceRow label="Order Fee" value={isFreeDelivery ? 'FREE' : orderFee} />
      <PriceRow
        label={`Coupon ${couponCode}`}
        value={couponAmount}
        negativeValue
        hide={!couponApplied}
      />
      <PriceRow label="Credit" value={creditsUsed} negativeValue hide={!creditsApplied} />
      <PriceRow label="Subtotal" value={subtotal} />
    </>
  )
}

const SubtotalPostTax = ({
  programAmount,
  programApplied,
  programCode,
  storedCurrencyAmount,
  storedCurrencyApplied,
  taxes = 0,
}) => {
  return (
    <>
      <PriceRow label="Taxes" value={taxes} />
      <PriceRow label={programCode} value={programAmount} negativeValue hide={!programApplied} />
      <PriceRow
        label="Gift"
        value={storedCurrencyAmount / 100}
        negativeValue
        hide={!storedCurrencyApplied}
      />
    </>
  )
}

const DeliveryFeeContribution = ({ deliveryFeeContribution }) => {
  const reserveFeeNotice =
    'The reserve fee ensures exclusive delivery to your location at a set time and varies by restaurant choice and other factors.'
  return (
    <>
      <PriceRow
        label="Reserve Fee"
        value={deliveryFeeContribution}
        showToolTip={true}
        toolTipLabel={reserveFeeNotice}
      />
    </>
  )
}

const PriceBreakdown = props => {
  const { orderTotal, deliveryFeeContribution } = props

  return (
    <>
      {deliveryFeeContribution > 0 && (
        <>
          <Box marginY={3}>
            <Divider />
          </Box>
          <DeliveryFeeContribution deliveryFeeContribution={deliveryFeeContribution} />{' '}
          <Box marginY={3}>
            <Divider />
          </Box>
        </>
      )}
      <SubtotalPreTax {...props} />
      <Box marginY={3}>
        <Divider />
      </Box>

      <SubtotalPostTax {...props} />
      <Box marginY={3}>
        <Divider />
      </Box>

      <PriceRow primary label="Total" value={orderTotal} />
    </>
  )
}

export default PriceBreakdown
